
// Thresholds
export const sample_interval = 100;
const obj_thresh = {
    'thresh_down_samples': 700/sample_interval,
    // changed the stop sample threshold from 1000 to 2000 on 2026-04-02 in main
    'thresh_stop_samples': 2000/sample_interval,
    'thresh_timeout_samples': 5000/sample_interval,
    'thresh_abs_sil': 1e-4
};

// Speech States: 'wait_slope','slope_down','silence_after','stop_recording'

class SpeechSignal {
    constructor () {
        this.init ();
    }
    init () {
        this.down_count = 0;
        this.down_start = -1;
        this.sil_after_count = 0;
        this.sil_after_start = -1;
        this.mean_sig = 0;
        this.prev_val = 0;
        this.count = 0;
        this.state = 'wait_slope';
    }
}
const obj_sig = new SpeechSignal();

export function endSpeech(val) {
    obj_sig.mean_sig = (obj_sig.mean_sig * obj_sig.count + val) / (obj_sig.count + 1);
    let diff = val - obj_sig.prev_val;
    let curr_state = obj_sig.state;

    switch (curr_state) {
        case 'wait_slope':
            if (diff < 0) {
                obj_sig.down_start = obj_sig.count
                obj_sig.down_count = 1
                curr_state = 'slope_down'
            } else {
                if ((obj_sig.count >= obj_thresh['thresh_timeout_samples']) && (obj_sig['mean_sig'] < obj_thresh['thresh_abs_sil'])) {
                    curr_state = 'stop_recording'
                }
            }
            break;
        case 'slope_down':
            if (diff < 0) {
                if (obj_sig.down_count > obj_thresh['thresh_stop_samples']) {
                    curr_state = 'stop_recording'
                } else {
                    obj_sig['down_count'] += 1
                }
            } else if ((obj_sig.down_count > obj_thresh['thresh_down_samples']) && (val < obj_sig.mean_sig / 3.)) {
                curr_state = 'silence_after'
                obj_sig.sil_after_start = obj_sig.count
                obj_sig.sil_after_count = 1
            } else {
                obj_sig.down_count = 0
                obj_sig.down_start = -1
                curr_state = 'wait_slope'
            }
            break;
        case 'silence_after':
            if ((obj_sig.down_count + obj_sig.sil_after_count) > obj_thresh['thresh_stop_samples']) {
                curr_state = 'stop_recording'
            } else if (val < obj_sig.mean_sig / 3.) {
                obj_sig.sil_after_count += 1
            } else {
                obj_sig.down_count = 0;
                obj_sig.down_start =-1;
                obj_sig.sil_after_start = 0;
                obj_sig.sil_after_count = -1;
                curr_state = 'wait_slope'

            }
            break;
        case 'stop_recording':            
            break;
        default:
            // Optional: handle unexpected states
            console.error(`Unexpected speech state: ${curr_state}. Resetting state.`);
            curr_state = 'wait_slope';
            break;
    }

    obj_sig.count += 1;
    obj_sig.prev_val = val;
    obj_sig.state = curr_state;

    if (curr_state === 'stop_recording') {
        // console.log('stopped recording:', obj_sig);
        obj_sig.init();
        return true;
    } 
    return false;
}